import req from '../http.js';

// 新增提交服务
export const addPipeline = (params) => {
  return req('post', '/console/pipeline-instance/addPipeline', params);
};
// 新增提交服务
export const editPipeline = (params) => {
  return req('post', '/console/pipeline-instance/updatePipeline', params);
};
// pipeline列表
export const getPipelineList = (params) => {
  return req('get', '/console/pipeline-instance/getPipelineList', params);
};
// pipeline详情
export const getPipelineInfo = (params) => {
  return req('get', '/console/pipeline-instance/getPipelineInfo', params);
};
// 删除pipeline
export const deletePipeline = (params) => {
  return req('get', '/console/pipeline-instance/deletePipeline', params);
};
// 新增提交服务
export const addService = (params) => {
  return req('post', '/console/pipeline-submit-instance/addOrEdit', params);
};
// 提交服务列表
export const getServiceList = (params) => {
  return req('get', '/console/pipeline-submit-instance/getList', params);
};
// 提交服务详情
export const getServiceInfo = (params) => {
  return req('get', '/console/pipeline-submit-instance/getDetail', params);
};
// 删除提交服务
export const deleteService = (params) => {
  return req('get', '/console/pipeline-submit-instance/deleteSubmitInstance', params);
};
// sink新增
export const addSink = (params) => {
  return req('post', '/console/pipeline-sink/addSink', params)
}
// sink修改
export const editSink = (params) => {
  return req('post', '/console/pipeline-sink/updateSink', params)
}
// sink列表
export const getSinkList = (params) => {
  return req('get', '/console/pipeline-sink/getSinkList', params);
};
// sink详情
export const getSinkInfo = (params) => {
  return req('get', '/console/pipeline-sink/getSinkInfo', params);
};
// 删除sink
export const deleteSink = (params) => {
  return req('get', '/console/pipeline-sink/deleteSink', params);
};
// 新增source

export const addSource = (params) => {
  return req('post', '/console/pipeline-source/addSource', params);
};
// 修改source
export const editSource = (params) => {
  return req('post', '/console/pipeline-source/updateSource', params);
};
// source列表
export const getSourceList = (params) => {
  return req('get', '/console/pipeline-source/getSourceList', params);
};
// source详情
export const getSourceInfo = (params) => {
  return req('get', '/console/pipeline-source/getSourceInfo', params);
};
// 删除source
export const deleteSource = (params) => {
  return req('get', '/console/pipeline-source/deleteSource', params);
};
// 获取kafka列表
export const getKafkaList = (params) => {

  return req('get', '/console/pipeline-kafka-cluster/getList', params);
};
export const getTopicList = (params) => {
  return req('get', '/console/pipeline-topic/getListByKafkaClusterID', params);
};
export const getPartitionList = (params) => {
  return req('get', '/console/pipeline-partition/getListByTopicID', params);
};
export const getDbList = (params) => {
  return req('get', '/console/pipeline-physical-db/getPhysicalDbListByUseOut', params);
};
// 新增路由
export const addRoute = (params) => {
  return req('post', '/console/pipeline-route/addRoute', params);
};
// 修改路由
export const editRoute = (params) => {
  return req('post', '/console/pipeline-route/updateRoute', params);
};
// 删除路由
export const deleteRoute = (params) => {
  return req('get', '/console/pipeline-route/deleteRoute', params);
};
export const getPipelineNList = (params) => {
  return req('get', '/console/pipeline-instance/getPipelineListForSubmit', params)
}
export const getSourceUnUsedList = (params) => {
  return req('get', '/console/pipeline-source/getSourceUnuseList', params)
}
export const getSinkUnUsedList = (params) => {
  return req('get', '/console/pipeline-sink/getSelectableSinkList', params)
}

